// src/lib/firebaseCompat.js
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

// Read env from Vite (VITE_*) or CRA (REACT_APP_*)
const env = (key) => {
  const vite =
    typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env[`VITE_${key}`];
  const cra =
    typeof process !== "undefined" &&
    process.env &&
    process.env[`REACT_APP_${key}`];
  return vite ?? cra;
};

const firebaseConfig = {
  apiKey: env("FIREBASE_API_KEY") || "AIzaSyDBNs2IeeOQrdjEU7hpXIpnaSu1JIDCWJI",
  authDomain:
    env("FIREBASE_AUTH_DOMAIN") || "towingportal-8bc42.firebaseapp.com",
  projectId: env("FIREBASE_PROJECT_ID") || "towingportal-8bc42",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();

export function signInEmailPass(email, password) {
  return auth.signInWithEmailAndPassword(email, password);
}

export async function signInWithPersistence(email, password, remember = true) {
  await auth.setPersistence(
    remember
      ? firebase.auth.Auth.Persistence.LOCAL
      : firebase.auth.Auth.Persistence.SESSION
  );
  return auth.signInWithEmailAndPassword(email, password);
}

export async function getIdToken(forceRefresh = false) {
  const u = auth.currentUser;
  return u ? u.getIdToken(forceRefresh) : null;
}

export function logout() {
  return auth.signOut();
}

export default firebase;
